import styled, { keyframes } from "styled-components";
import loginBackground from "../../../assets/login-background.jpg";
import { shade } from "polished";

export const Container = styled.div`
  height: 100vh;

  display: flex;
  align-items: stretch;
  background: #fff;
  color: #f4ede8;
  -webkit-font-smoothing: antialiased;

  input {
    font-family: "Ubuntu", sans-serif;
    height: calc(1.8em + 1rem + 2px) !important;
    padding: 15px !important;
    line-height: 1.8 !important;
    border-radius: 6px !important;
    color: #cb642e !important;
    display: block;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    background-clip: padding-box;
    border: 1px solid #cb642e;
    background: #fff !important;
  }

  input:last-child {
    margin-bottom: 12px !important;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  strong {
    font-weight: 500;
    color: #2e3f72;
  }

  button {
    cursor: pointer;

    color: #fff;
    background-color: #2e3f72;
    border-color: #0081ac;
    -webkit-box-shadow: 0;
    box-shadow: 0;
    display: block;
    width: 100%;
    font-weight: 600;
    padding: 0.5rem 1rem;
    font-size: 16px;
    line-height: 1.8;
    border-radius: 6px;
    margin-top: 12px !important;

    height: calc(1.8em + 1rem + 2px) !important;
    font-weight: 400;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 500px;

  img {
    width: 300px;
    height: 130px;
  }

  h1 {
    color: #2e3f72;
  }
`;

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px)
  }
  to {
    opacity: 1;
    transform: translateX(0)
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  animation: ${appearFromLeft} 1s;

  form {
    margin: 80px 0;
    width: 340px;
    text-align: center;

    h1 {
      margin-bottom: 24px;
      color: #2e3f72;
    }

    a {
      color: #f4ede8;
      display: block;
      margin-top: 24px;
      text-decoration: none;
      transition: color 0.3s;

      &:hover {
        color: ${shade(0.2, "#f4ede8")};
      }
    }
  }

  > a {
    color: #ff9000;
    display: block;
    margin-top: 24px;
    text-decoration: none;
    transition: color 0.3s;

    display: flex;
    align-items: center;

    svg {
      margin-right: 16px;
    }

    &:hover {
      color: ${shade(0.2, "#ff9000")};
    }
  }
`;

export const Background = styled.div`
  flex: 1;
  background: url(${loginBackground}) no-repeat center;
  background-size: cover;
`;

export const ForgotPassword = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  color: #333;
  font-size: 16px;

  > a {
    margin: 0 !important;
    padding-left: 10px !important;
    color: #0082af !important;
    text-decoration: none !important;

    &:link {
      color: #0082af !important;
      text-decoration: none !important;
    }
    &:visited {
      color: #a435f0 !important;
      text-decoration: none !important;
    }
    &:hover {
      opacity: 0.7;
      text-decoration: none !important;
    }
  }
`;
